import React from 'react'

import { Container } from './styles'

export const Footer: React.FC = () => {
  return (
    <Container>
      <p>Request Portal</p>
    </Container>
  )
}
